<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("net_revenue_report") }}
      </div>

      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="dropDown.cinemas && dropDown.cinemas.length > 0
                ? 'shift-up'
                : ''
                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
              <multiselect v-model="dropDown.selectedCinema" :allowEmpty="true" :disabled="isRoleID"
                :options="dropDown.cinemas" :searchable="true" :showLabels="false" label="cine_name"
                placeholder="Select Cinema" track-by="cine_id" @input="onSelectCinema($event)"></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label :class="filter_key_array.length > 0 ? 'shift-up' : ''">
                {{ $t("Select ") }} {{ $tc("Filter", 1) }}
              </label>

              <multiselect v-model="filter_value" :allowEmpty="true" :disabled="isRoleID" :options="filter_key_array"
                :searchable="true" :showLabels="false" placeholder="Select Filter"></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <button v-if="fromDate" class="btn-clearDate">✖</button>
                <Datepicker ref="programaticOpen" v-model="fromDate" v-validate="'required'" :monday-first="true"
                  type="date" @selected="onChangeDate($event, 'from')"></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <button v-if="toDate" class="btn-clearDate">✖</button>
                <Datepicker ref="programaticOpen" v-model="toDate" v-validate="'required'" :monday-first="true">
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <button class="btn-blue-lg w-100" @click.prevent="getNetRevReport({ isPdf: 'N', isExcel: 'N' })">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div v-if="getReportList.length > 0"
            class="col-lg-12 col-xl-12 align-self-center mt-2 d-flex justify-content-end">
            Download as :
            <span download style="cursor: pointer" title="Download as Pdf"
              @click="getNetRevReport({ isPdf: 'Y', isExcel: 'N' })">
              <img height="25" src="@/assets/img/icons/pdf.svg" width="25" />
            </span>
            <span download style="cursor: pointer" title="Download as Excel"
              @click="getNetRevReport({ isPdf: 'N', isExcel: 'Y' })">
              <img height="25" src="@/assets/img/icons/excel.svg" width="25" />
            </span>
          </div>
        </div>
      </div>

      <div>
        <div class="table-scroll">
          <table border="1" class="swc-report-table">
            <thead>
              <tr class="bg-lightgrey font-weight-bold">
                <th rowspan="2">Cinema Name</th>
                <th colspan="4">Net Sales</th>
              </tr>
              <tr class="bg-lightgrey font-weight-bold">
                <th>Ticket</th>
                <th>3D</th>
                <th>FnB</th>
                <th>DTA & Others</th>
              </tr>
            </thead>
            <tbody v-if="getReportList.length > 0">
              <tr v-for="(reportData, reportDataIndex) in getReportList" :key="reportDataIndex">
                <td class="text-left">
                  {{ reportData.cinema_name }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_net) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_3d) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_fnb_net) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_dta_net || 0) }}
                </td>
              </tr>

              <tr v-for="(reportData, reportDataIndex) in grandTotal" :key="reportDataIndex"
                class="bg-lightgrey font-weight-bold">
                <td class="text-left">
                  {{ reportData.cinema_name }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_net) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_3d) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_fnb_net) }}
                </td>

                <td class="text-right">
                  {{ currFormat(reportData.display_dta_net || 0) }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="13">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import NewReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import * as XLSX from "xlsx";

export default {
  name: "NetRevenueReport",
  components: {
    NoRecords,
  },
  data() {
    return {
      isExcel: "N",
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: moment().toDate(),
      toDate: new Date(),
      filter_key_array: ["Show Date", "Transaction Date"],
      filter_value: "Transaction Date",
      grandTotal: [],
      getReportList: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      if (CinemaObj.cine_id != "all") {
        this.onSelectCinema(CinemaObj);
      }
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        if (CinemaObj.cine_id != "all") {
          this.onSelectCinema(CinemaObj);
        }
      }
    },
  },
  computed: {},
  mounted() { },
  methods: {
    moment,
    onChangeDate(e, type) {
      console.log("onChangeDate", type);
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    getNetRevReport({ isPdf = "N", isExcel = "N" }) {
      this.submitted = true;
      this.getReportList = [];
      this.grandTotal = [];

      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show(`Please Select Cinema`);
        return false;
      }

      let selectedCinemaId =
        this.dropDown.selectedCinemaId == 0
          ? this.CinemasCopy.map((x) => {
            return x.cine_id;
          })
          : [this.dropDown.selectedCinemaId];

      if (!this.fromDate) {
        return this.$toasted.show("From Date field cannot be empty");
      }
      if (!this.toDate) {
        return this.$toasted.show("To Date field cannot be empty");
      }
      if (moment(this.fromDate).isAfter(moment(this.toDate))) {
        return this.$toasted.show("To date should be greater than from date");
      }

      let loader = this.$loading.show();

      let payload = {
        cinema_id: selectedCinemaId[0] || "",
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        excel: isExcel,
        isPdf: isPdf,
        is_filter_show_date: this.filter_value == "Show Date",
      };

      NewReportsService.GetNewRevenueReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.getReportList = [...data.Records];
            this.grandTotal = [...(data.GrandTotal || [])];
          } else {
            this.$toasted.show(data.message);
          }
          if (data.excelUrl && isExcel == "Y") {
            window.open(data.excelUrl, "_blank");
          } else if (data.pdfPath && isPdf == "Y") {
            window.open(data.pdfPath, "_blank");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((e) => {
          console.log("GetNewRevenueReport Error", { e });

          this._CatchError(e);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // let cinemas = [
            //   {
            //     cine_id: "all",
            //     cine_name: "All Cinemas",
            //   },
            // ];
            let role_is_cinema_level = this.secureStore.get("USINFO")
              .cinema_id;
            this.dropDown.cinemas = [...data.Records];
            this.CinemasCopy = [...data.Records];
            if (!role_is_cinema_level) {
              this.dropDown.cinemas = [ ...data.Records];
              this.CinemasCopy = [ ...data.Records];
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      if (event.cine_id != "all") {
        this.$store.dispatch("selectDropdownCinema", event);
      }
    },
  },
  beforeDestroy: async function () {
    // remove file
  },
};
</script>

<style scoped>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.reportp-tr td {
  width: 13%;
  border: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/NetRevenueReport.vue